export default __webpack_public_path__ + "static/media/stylecanopies.913a17fb.jpeg";